import React, { useState, useEffect } from 'react';
import GraficosEstadosExpedientes from './GraficosEstadosExpedientes';
import GraficoEstadosContraventores from './GraficoEstadosContraventores';
import SelectorOrganismo from '../../common/SelectorOrganismo';
import SelectorAnio from '../../common/SelectorAnio';
import { useQuery } from '@apollo/react-hooks';
import _ from 'lodash';
import getEstadosExpedientesPorMes from '../../../graphql/querys/contravenciones/getEstadosExpedientesPorMes.graphql';
import getEstadosContraventoresPorMes from '../../../graphql/querys/contravenciones/getEstadosContraventoresPorMes.graphql';

const ContainerGraficos = props => {
  const [idOrganismo, setIdOrganismo] = useState(props.usuario.organismo._id);
  const [anio, setAnio] = useState('2020');
  const queryEstadosExpedienteMes = useQuery(getEstadosExpedientesPorMes, {
    fetchPolicy: 'network-only',
    variables: {
      anio: anio,
      idOrganismo: idOrganismo,
    },
  });

  const queryEstadosContraventores = useQuery(getEstadosContraventoresPorMes, {
    fetchPolicy: 'network-only',
    variables: {
      anio: anio,
      idOrganismo: idOrganismo,
    },
  });

  useEffect(() => {
    queryEstadosExpedienteMes.refetch({ anio: anio, idOrganismo: idOrganismo });
    queryEstadosContraventores.refetch({
      anio: anio,
      idOrganismo: idOrganismo,
    });
  }, [idOrganismo, anio]);

  return (
    <>
      <SelectorOrganismo
        onChangeOrganismo={id => setIdOrganismo(id)}
        usuario={props.usuario}
        idOrganismo={idOrganismo}
      />
      <SelectorAnio onChangeAnio={anio => setAnio(anio)} />
      <GraficosEstadosExpedientes
        loading={queryEstadosExpedienteMes.loading}
        data={_.get(
          queryEstadosExpedienteMes,
          'data.getEstadosExpedientesPorMes',
          []
        )}
      />
      <GraficoEstadosContraventores
        loading={queryEstadosContraventores.loading}
        data={_.get(
          queryEstadosContraventores,
          'data.getEstadosContraventoresPorMes',
          []
        )}
      />
    </>
  );
};

export default ContainerGraficos;
